module.exports = __webpack_public_path__ + "media/images/writer/monitor/txt-about@2x-44e0591cc5e086407ec673b904746fbb.png";